import {Injectable} from '@angular/core';
import {ResetPasswordComponent} from '../../account/reset-password/reset-password.component';
import {LoginComponent} from '../../account/login/login.component';
import {ConfirmDialogComponent} from '../../confirm/confirm-dialog.component';
import {GenericModalComponent} from '../../generic-modal/generic-modal.component';
import {ParserLimitationInfoModalComponent} from '../../custom-modals/parser-limitation-info-modal.component';
import {VerifyYourEmailModalComponent} from '../../custom-modals/verify-your-email-modal.component';
import {UnsubscribePaymentModalComponent} from '../../custom-modals/unsubscribe-payment-modal.component';
import {MessageResendModalComponent} from '../../custom-modals/message-resend-modal.component';
import {VerifyYourEmailValidationModalComponent} from '../../custom-modals/verify-your-email-validation-modal.component';
import {UnsubscribedUserModalComponent} from '../../custom-modals/unsubscribed-user-modal.component';
import {MigrationNoticeModalComponent} from '../../custom-modals/migration-notice-modal.component';
import {SignupNoticeModalComponent} from '../../custom-modals/signup-notice-modal.component';
import {CreateComponent} from '../../account/create/create.component';
import {ModalService} from './modal.service';
import {GoogleAnalyticsService} from '../google-analytics-service';
import { TranslateService } from '@ngx-translate/core';
import {Observable} from 'rxjs/Observable';
import {Location} from '@angular/common';
import {LocalStorageService} from 'angular-2-local-storage';

interface ModalParams {
    title?: string;
    message: string;
    showCancelButton?: boolean;
    [x: string]: any;
}


@Injectable()
export class ModalHelper {
  constructor(private ga: GoogleAnalyticsService,
              private modalService: ModalService,
              private translate: TranslateService,
              private location: Location,
              private localStorageService: LocalStorageService) {
  }

  openReset(data, next: any) {
      this.modalService.open(ResetPasswordComponent, {
          title: 'Reset Password',
          data: data
      }).subscribe(model => {
          if (next) {
              next(model);
          }
      });
  }

    openLogin(param) {
        this.modalService.open(LoginComponent, {
            title: 'SIGN IN',
            data: param
        }).subscribe((model) => {
            if (model === 'SIGN UP') {
            	if(param && param.winReload) {
        			let data : any = {};
        			data.winReload = param.winReload;
        			this.openCreate(data, null);
        		} else {
        			this.openCreate({}, null);
        		}
            } else {
            	if(model === 'CLOSE LOG IN') {
            		if(this.localStorageService.get('isAccessLogInMenu')) {
            			document.getElementsByTagName('body')[0].classList.add('modal-open');
            		}
            		//this.localStorageService.set('isAccessLogInMenu', false);
            	} else if(model === 'REPORTS PAGE') {
            		if(this.localStorageService.get('isAnonymousReport')) {
            			this.localStorageService.remove('isAnonymousReport');
            			this.location.go('/reports/myreports');
            			window.location.reload();
            		} else {
            			window.location.href='/#/reports/myreports';
            		}
            	}
            }
        });
    }

    openConfirm(param: ModalParams = <ModalParams>{}, next: any) {
        this.modalService.open(ConfirmDialogComponent, {
          title: param.title ? param.title : this.translate.instant('common.info'),
          data: param,
          showCancelButton: false
        }).subscribe((model) => {
            if (next) {
                next(model);
            }
        });
    }
    
    openGeneric(param: ModalParams = <ModalParams>{}, next: any) {
        this.modalService.open(GenericModalComponent, {
          title: param.title ? param.title : this.translate.instant('common.info'),
          data: param
        }).subscribe((model) => {
            if (next) {
                next(model);
            }
        });
    }

    openCreate(param, next: any) {
        this.openSignupNotice();
    }

    /** TASK2: Sign-up transition modal (replaces the old migration notice). */
    openSignupNotice() {
        this.modalService.open(SignupNoticeModalComponent, {
            title: this.translate.instant('transition.signup.title'),
            data: {}
        }).subscribe((model) => {
            // "Already have an account?" -> capture the real sign-in email via the login form.
            if (model === 'OPEN_LOGIN') {
                this.openLogin({});
            }
        });
    }

    openMigrationNoticeModal() {
        this.modalService.open(MigrationNoticeModalComponent, {
            title: this.translate.instant('account.migrationNotice.title'),
            data: {
                message: this.translate.instant('account.migrationNotice.message'),
                registerText: this.translate.instant('account.migrationNotice.registerText'),
                registerLinkText: this.translate.instant('account.migrationNotice.registerLinkText'),
                loginText: this.translate.instant('account.migrationNotice.loginText'),
                loginLinkText: this.translate.instant('account.migrationNotice.loginLinkText')
            }
        });
    }
    
    openFilesLimitUploadModal(param: ModalParams = <ModalParams>{}, next: any) {
        this.modalService.open(ParserLimitationInfoModalComponent, {
          title: param.title ? param.title : this.translate.instant('common.info'),
          data: param,
          showCancelButton: false
        }).subscribe((model) => {
            if (next) {
                next(model);
            }
        });
    }
    
    openVerifyYourEmailModal(param: ModalParams = <ModalParams>{}, next: any) {
        this.modalService.open(VerifyYourEmailModalComponent, {
          title: param.title ? param.title : this.translate.instant('common.info'),
          subtitle : param.subtitle ? param.subtitle : this.translate.instant('common.info'),
          data: param
        }).subscribe((model) => {
            if (next) {
                next(model);
            }
        });
    }
    
    openUnsubscribePaymentModal(param: ModalParams = <ModalParams>{}, next: any) {
        this.modalService.open(UnsubscribePaymentModalComponent, {
          title: param.title ? param.title : this.translate.instant('common.info'),
          subtitle : param.subtitle ? param.subtitle : this.translate.instant('common.info'),
          data: param
        }).subscribe((model) => {
            if (next) {
                next(model);
            }
        });
    }
    
    openVerifyYourEmailValidationModalComponent(param: ModalParams = <ModalParams>{}, next: any) {
        this.modalService.open(VerifyYourEmailValidationModalComponent, {
          title: param.title ? param.title : this.translate.instant('common.info'),
          data: param
        }).subscribe((model) => {
            if (next) {
                next(model);
            }
        });
    }
    
    openUnsubscribedUserModal(param: ModalParams = <ModalParams>{}, next: any) {
        return this.modalService.open(UnsubscribedUserModalComponent, {
          title: param.title ? param.title : this.translate.instant('common.info'),
          data: param
        });
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/services/modalService/modal.helper.ts